import { render, staticRenderFns } from "./CreateSubCategory.vue?vue&type=template&id=4bc27d98&scoped=true&"
import script from "./CreateSubCategory.vue?vue&type=script&lang=js&"
export * from "./CreateSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubCategory.vue?vue&type=style&index=0&id=4bc27d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc27d98",
  null
  
)

export default component.exports